import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, KeyRound, Trash2, ShieldCheck } from "lucide-react";
import { prodApi, errMsg } from "./prodApi";
import { useProd } from "./ProdApp";
import { PButton, PInput, PField, PTitle, PCard, PModal, PEmpty, PBadge } from "./ProdUi";

export default function ProdUsers() {
  const { user } = useProd();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", is_manager: false });
  const isAdmin = user?.role === "admin" || user?.role === "superadmin";

  const load = () => prodApi.get("/production/users").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { if (isAdmin) load(); }, [isAdmin]);

  if (!isAdmin) return <PEmpty title="Sezione riservata all'amministratore" />;

  const create = async () => {
    if (!f.name.trim() || !f.email.trim() || f.password.length < 6) { toast.error("Nome, email e password (min 6 caratteri)"); return; }
    try { await prodApi.post("/production/users", f); toast.success("Utente Produzione creato"); setOpen(false); setF({ name: "", email: "", password: "", is_manager: false }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const toggleManager = async (u) => {
    try { await prodApi.patch(`/production/users/${u.id}`, { is_manager: !u.production_manager }); toast.success(u.production_manager ? "Flag responsabile rimosso" : "Ora è responsabile di produzione"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const resetPwd = async (u) => {
    const p = window.prompt(`Nuova password per ${u.email} (min 6 caratteri):`);
    if (!p) return;
    try { await prodApi.patch(`/production/users/${u.id}`, { password: p }); toast.success("Password aggiornata"); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`Eliminare l'utente ${u.email}?`)) return;
    try { await prodApi.delete(`/production/users/${u.id}`); toast.success("Utente eliminato"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="prod-users-page">
      <PTitle kicker="Amministrazione" title="Utenti Produzione" right={<PButton variant="primary" onClick={() => setOpen(true)} data-testid="prod-user-new-btn"><Plus className="w-5 h-5" /> Nuovo utente</PButton>}>
        Gli utenti Produzione entrano da /produzione. Il flag "Responsabile" permette di modificare albero, ricette e costi standard.
      </PTitle>
      {!list.length && <PEmpty title="Nessun utente Produzione" text="Crea gli operatori di reparto: potranno registrare rese reali e fare simulazioni." />}
      <div className="space-y-2">
        {list.map((u) => (
          <PCard key={u.id} className="flex flex-col md:flex-row md:items-center gap-3" data-testid={`prod-user-row-${u.id}`}>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-white">{u.name} {u.production_manager && <PBadge tone="blue" className="ml-1">Responsabile</PBadge>}</p>
              <p className="text-xs text-slate-400">{u.email}</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <PButton size="sm" onClick={() => toggleManager(u)} data-testid={`prod-user-toggle-manager-${u.id}`}><ShieldCheck className="w-4 h-4" /> {u.production_manager ? "Togli responsabile" : "Rendi responsabile"}</PButton>
              <PButton size="sm" onClick={() => resetPwd(u)} data-testid={`prod-user-reset-${u.id}`}><KeyRound className="w-4 h-4" /> Password</PButton>
              <PButton size="sm" variant="danger" onClick={() => remove(u)} data-testid={`prod-user-delete-${u.id}`}><Trash2 className="w-4 h-4" /></PButton>
            </div>
          </PCard>
        ))}
      </div>
      <PModal open={open} onClose={() => setOpen(false)} title="Nuovo utente Produzione">
        <div className="space-y-3" data-testid="prod-user-form">
          <PField label="Nome"><PInput value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Mario Rossi" data-testid="prod-user-name" /></PField>
          <PField label="Email"><PInput type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="mario@giotto.it" data-testid="prod-user-email" /></PField>
          <PField label="Password"><PInput value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="min 6 caratteri" data-testid="prod-user-password" /></PField>
          <label className="flex items-center gap-3 h-12 text-sm text-slate-300"><input type="checkbox" className="w-6 h-6 accent-blue-500" checked={f.is_manager} onChange={(e) => setF({ ...f, is_manager: e.target.checked })} data-testid="prod-user-manager" /> Responsabile di produzione (può configurare albero, ricette e costi)</label>
          <div className="flex gap-2 justify-end"><PButton onClick={() => setOpen(false)}>Annulla</PButton><PButton variant="primary" onClick={create} data-testid="prod-user-create">Crea</PButton></div>
        </div>
      </PModal>
    </div>
  );
}
